import { GraphQLClient, RequestMiddleware } from "graphql-request";

import { getEnvironmentVariable } from "@/common/services/env";

import { fetchRetry } from "./fetch-retry";
import { token } from "./token";

const requestMiddleware: RequestMiddleware = async (request) => {
  const controller = new AbortController();
  return {
    ...request,
    headers: {
      ...request.headers,
      Authorization: `Bearer ${await token.read({ forced: false })}`,
      "Content-Type": "application/json",
    },
    signal: controller.signal,
  };
};

const graphqlClient = new GraphQLClient(
  getEnvironmentVariable("DIGITALNI_SKLADY_API_URL"),
  {
    fetch: (input, init) =>
      fetchRetry({
        // @ts-expect-error err
        data: JSON.parse(init?.body),

        // @ts-expect-error err
        headers: init?.headers,

        // @ts-expect-error err
        method: init?.method,

        retries: 1,
        signal: init?.signal ?? undefined,
        url: input.toString(),
      }),
    requestMiddleware,
  },
);

export { graphqlClient };
